<template>
    <div>
        <div class="cc-banner"
        data-content-text="Używamy plików cookie i innych technologii w celu poprawy i personalizacji doświadczenia użytkownika, analityki w celu optymalizacji i reklamy we współpracy z osobami trzecimi. Używamy naszych własnych plików cookie oraz plików cookie od osób trzecich. Klikając OK akceptujesz użycie wszystkich plików cookie. Zawsze {preferencesUrl}ustawiamy{/preferencesUrl} niezbędne pliki cookie. Wybierz opcję Ustawienia, aby wybrać pliki cookie, które chcesz zaakceptować, dostosować swoje preferencje i uzyskać więcej informacji."
        data-url="https://www.pyszne.pl/polityka-cookies"
        data-url-text="ustawiamy."
        data-hide-link-after-text="true"
        data-button-text="OK"
        data-button-text-aria="OK Button"
        data-button-essential-package="Podstawowy"
        data-button-essential-package-aria="Essential package aria">
        </div>

    </div>
</template>

<script>

export default {
    mounted() {
        window.addEventListener('load', () => this.addCookies());
    },
    data: function() {
        return {
        }
    },
    methods: {
        addCookies() {
            let cookie;
            let name = "cookieConsent=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');

            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    cookie = c.substring(name.length, c.length);
                }
            }

            if (cookie == undefined) {

                let cookiesScript = document.createElement('script')
                cookiesScript.setAttribute('src', 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/cookie-styles-09-2022/cookie-wall-with-polyfill.59c6866ee421a693445a.js');
                document.head.appendChild(cookiesScript);

            }
        }
    }
}
</script>